// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3w7pf","rightAdornment":"Header_rightAdornment__3G_xv"};